(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["two-images-section"] && !Shopify.designMode) return;
  try {
    
  // Expose the gap as a CSS variable (so you can use the same value in CSS)
  (function () {
    const section = document.currentScript.closest('.two-images-section');
    if (!section) return;
    section.style.setProperty('--gap', '{{ section.settings.gap }}px');
  })();

  } catch(e) { console.error(e); }
})();
})();
